function MailIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M22 7l-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7m2-3h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default MailIcon;
